import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ISpeakingRubricListItem } from '../../../models/newSpeaking.model';
import { Table, TableColumnsType } from 'antd';
import Button from '../../Button';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  data?: ISpeakingRubricListItem[];
}

const SpeakingRubricTable: FC<IProps> = ({
  data,
}) => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();

  const columns: TableColumnsType<ISpeakingRubricListItem> = [
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value, i18n.language),
    },    
    {
      title: t('cbt.speakingRubric.3'),
      dataIndex: 'rubricType',
      align: 'center',
      render: value => getCommonCodeLabel('TE0010', value, i18n.language),
    },
    {
      title: t('cbt.speakRubric.column10'),
      dataIndex: 'rubricName',
      align: 'center',
    },
    {
      title: t('cbt.speakRubric.column2'),
      dataIndex: 'useYN',
      align: 'center',
    },
    {
      title: t('common.button.edit'),
      align: 'center',
      render: ({ rubricNo }: ISpeakingRubricListItem) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small pink-line"
            onClick={() => history.push(`/cbt/speaking-rubric/${rubricNo}/edit`)}
            text={t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      ),
    },
    {
      title: t('common.button.detail'),
      align: 'center',
      render: ({ rubricNo }: ISpeakingRubricListItem) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small mint"
            onClick={() => history.push(`/cbt/speaking-rubric/${rubricNo}`)}
            text={t('common.button.detail')}
          />
        </div>
      ),
    },
  ];

  return (
    <div className='comm-table__area'>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 99999 }}
      />
    </div>
  );
};

export default SpeakingRubricTable;
